import { render, staticRenderFns } from "./RoomRegister.vue?vue&type=template&id=68a320f4&scoped=true&lang=pug"
import script from "./RoomRegister.vue?vue&type=script&lang=ts"
export * from "./RoomRegister.vue?vue&type=script&lang=ts"
import style0 from "./RoomRegister.vue?vue&type=style&index=0&id=68a320f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a320f4",
  null
  
)

export default component.exports